import IntoCartLayer from '../into-cart/IntoCartLayer.jsx';
import openLayer from '../layers/open-layer';
import fetchWithCSRF from '../../helper/fetch-with-csrf';
import Url from '../../helper/url';
import Logger from '../logger';
import MessageBroker from 'deprecated-shared-ui/components/message-broker';
import Messages from '../messages';

export default function (
    itemOptionId,
    shopId,
    digistyleId,
    itemNumber,
    fkIdOverride,
    pageShorthandOverride,
    origin,
    channelId,
    onRequestEnd
) {
    const ajaxUrl =
        `${Url.base()}ajax/intoCartLayer/` +
        `?itemOptionId=${itemOptionId ? itemOptionId : ''}` +
        `${shopId !== undefined && shopId !== null ? '&shopId=' + shopId : ''}` +
        `${digistyleId ? '&digistyleId=' + digistyleId : ''}` +
        `${itemNumber ? '&itemNumber=' + itemNumber : ''}` +
        `${fkIdOverride ? '&fkIdOverride=' + fkIdOverride : ''}` +
        `${pageShorthandOverride ? '&pageShorthandOverride=' + pageShorthandOverride : ''}` +
        `${origin ? '&origin=' + origin : ''}` +
        `${channelId ? '&channelId=' + channelId : ''}`;

    fetchWithCSRF(ajaxUrl)
        .then((response) => {
            if (!response.ok || response.status >= 400) {
                onRequestEnd?.();
                return Promise.reject({stack: `${response.status} - ${response.statusText}`});
            }
            return response.json();
        })
        .then(
            ({
                article,
                texts,
                pageLandmark,
                intoCartLayerGotoCartButtonUrl,
                intoCartLayerIntoCartClickLandmarkValue,
                intoCartLayerGoOnShoppingClickLandmarkValue,
                ajaxSwiperDataUrl,
                ajaxSwiperParamString,
            }) => {
                openLayer(IntoCartLayer, {
                    article,
                    texts,
                    pageLandmark,
                    intoCartLayerGotoCartButtonUrl,
                    intoCartLayerIntoCartClickLandmarkValue,
                    intoCartLayerGoOnShoppingClickLandmarkValue,
                    ajaxSwiperDataUrl,
                    ajaxSwiperParamString,
                });
                onRequestEnd?.();
                MessageBroker.publish(Messages.DOM.CHANGED);
            }
        )
        .catch((error) => {
            onRequestEnd?.();
            Logger.error('Error while fetching data for IntoCartLayer', error);
        });
}
